import Introduction from "./Introduction";
import Customer from "./Customer";
import UpdateDemand from "./UpdateDemand";
import CreateDemand from "./CreateDemand";
import InvoiceAction from "./InvoiceAction";
import PendingDemandsVendors from "./office/PendingDemandsVendors";
import PendingStatements from "./office/PendingStatements";
import ApproveStatement from "./office/ApproveStatements";

const appRoutes = [
  // {
  //   index: true,
  //   element: <DocsHome />,
  //   state: "home",
  // },
  {
    path: "/introduction",
    element: <Introduction />,
    state: "introduction",
    sidebarProps: {
      displayText: "Introduction",
    },
  },
  {
    path: "/customer",
    element: <Customer />,
    state: "customer",
    sidebarProps: {
      displayText: "Customer",
    },
    child: [
      {
        index: true,
        element: <Customer />,
        state: "customer.introduction",
      },
      {
        path: "/customer",
        element: <Customer />,
        state: "customer.create",
        sidebarProps: {
          displayText: "Create",
        },
      },
    ],
  },
  {
    path: "/demand",
    element: <CreateDemand />,
    state: "component",
    sidebarProps: {
      displayText: "Demand",
    },
    child: [
      {
        path: "/demand/create",
        element: <CreateDemand />,
        state: "demand.create",
        sidebarProps: {
          displayText: "Create",
        },
      },
      {
        path: "/demand/update",
        element: <UpdateDemand />,
        state: "demand.update",
        sidebarProps: {
          displayText: "Update",
        },
      },
    ],
  },
  {
    path: "/invoice-action",
    element: <InvoiceAction />,
    state: "invoiceaction",
    sidebarProps: {
      displayText: "Invoice Action",
    },
  },
  {
    path: "/office",
    // element: <Office />,
    state: "office",
    sidebarProps: {
      displayText: "Office",
    },
    child: [
      {
        path: "/office/pending-demands-vendors",
        element: <PendingDemandsVendors />,
        state: "office.pendingdemandsvendor",
        sidebarProps: {
          displayText: "Pending Demands Vendor",
        },
      },
      {
        path: "/office/pending-statements",
        element: <PendingStatements />,
        state: "office.pendingstatements",
        sidebarProps: {
          displayText: "Pending Statements",
        },
      },
      {
        path: "/office/approve-statement",
        element: <ApproveStatement />,
        state: "office.approvestatement",
        sidebarProps: {
          displayText: "Approve Statement",
        },
      },
    ],
  },
];

export default appRoutes;
